module.exports = __webpack_public_path__ + "img/fixing-bugs-dark.92550cbd.svg";